import { render, staticRenderFns } from "./selectLocation.vue?vue&type=template&id=2a185844&scoped=true"
import script from "./selectLocation.vue?vue&type=script&lang=js"
export * from "./selectLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a185844",
  null
  
)

export default component.exports